import { createBrowserHistory } from 'history';
import moment from 'moment';

export const history = createBrowserHistory({ basename: '/' });

export const deleteQueryParameters = (paramsToDelete: string[]) => {
  const urlParams = new URLSearchParams(history.location.search);

  paramsToDelete.forEach((paramName) => urlParams.delete(paramName));
  history.replace({ search: `?${urlParams.toString()}` });
};

export const extractQueryDatePeriod = () => {
  const params = new URLSearchParams(history.location.search);
  const selectedDateStr = params.get('date');
  const selectedDate = selectedDateStr
    ? Number.parseInt(selectedDateStr, 10)
    : undefined;
  const start = selectedDate && moment(selectedDate).startOf('day').valueOf();
  const end = selectedDate && moment(selectedDate).endOf('day').valueOf();

  return start && end && { start, end };
};
